import ACTION_TYPES from '../actions/actionTypes'

export default (state, action) => {

    switch (action.type) {

        case ACTION_TYPES.FETCH_PERF_GRID:
            return {
                ...state,
                railGridData: action.payload

            };
        case ACTION_TYPES.FETCH_PEOPLE:
            return {
                ...state,
                peopleList: action.payload

            };
        case ACTION_TYPES.FETCH_MOC:
            return {
                ...state,
                mocData: action.payload

            };

        case ACTION_TYPES.FETCH_GEMBA:
            return {
                ...state,
                gembaData: action.payload

            };

        case ACTION_TYPES.GET_MESSAGES:
            return {
                ...state,
                messages: action.payload
            };
        case ACTION_TYPES.GET_ALERTS:
            return { ...state, alerts: action.payload };
        case ACTION_TYPES.GET_DOWNTIME:
            return { ...state, downTimeData: action.payload }
        case ACTION_TYPES.GET_REASON_CODES:
            return { ...state, reasonCodes: action.payload }
        case ACTION_TYPES.FETCH_CALENDAR_PLAN:
            return { ...state, calendarInfo: action.payload }
        case ACTION_TYPES.FETCH_GEMBA_TYPES:
            return { ...state, gembaTypes: action.payload }
        case ACTION_TYPES.FETCH_TIER_LIST:
            return { ...state, tiersList: action.payload }
        case ACTION_TYPES.FETCH_INCIDENT:
            return {
                ...state,
                incidentData: action.payload

            };
        case ACTION_TYPES.GET_INCIDENT_TYPE:
            return { ...state, incidentType: action.payload }
        case ACTION_TYPES.FETCH_CALENDAR_EVENT_TYPES:
            return { ...state, calendarEventTypes: action.payload }
        case ACTION_TYPES.FETCH_ALL_USERS:
            return { ...state, allUsers: action.payload }
        case ACTION_TYPES.SAVE_HTML_TPL: {
            return { ...state, emailTpl: action.payload }
        }
        case ACTION_TYPES.FETCH_SCHEDULES:
            return { ...state, schedules: action.payload }
        case ACTION_TYPES.FETCH_TZ:
            return { ...state, timezones: action.payload }
        case ACTION_TYPES.GET_NOMINATION:
            return { ...state, allNominations: action.payload }
        case ACTION_TYPES.MANAGE_NOMINATION:
            return { ...state, manageNominations: action.payload }
        case ACTION_TYPES.FETCH_HSECOMMUNICATION:
            return { ...state, hseCommunicationData: action.payload }
        case 'USER_PREF':
            return { ...state, userPref: action.payload }
        case 'PPL_LIST_FROM_SITE':
            return { ...state, pplListInSite: action.payload }
        case 'FECTH_SMESS_CARDS':
            return { ...state, smessCards: action.payload }
        case ACTION_TYPES.GET_GEMBA_WALK_PRIORITIES_DATA:
            return { ...state, gembaWalkPrioritiesData: action.payload }
        case ACTION_TYPES.FETCH_MULTI_SURVEY_NAME_DATA:
            return { ...state, surveyNameData: action.payload }
        case ACTION_TYPES.GET_TIER_INFO:
            return { ...state, tierInfo: action.payload }
        default:
            return state;
    }
};